import React from 'react';
import PropTypes from 'prop-types';
import { InputLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as IconYes } from 'images/icon_yes.svg';
import { ReactComponent as IconNo } from 'images/icon_no.svg';
import SvgIcon from '@material-ui/core/SvgIcon';

const useStyles = makeStyles(theme => ({
  label: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  img: {
    width: '1.4rem',
    height: '1.4rem',
  },
  labelBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  }, //*[@id="Ellipse_373"] xpath can be found by right click on element copy > xpath in chrome
  mySvgStyle: {
    height: '25px',
    width: '25px',
    cursor: 'pointer',
    fill: `${theme.palette.secondary.light} !important`,
    '& [id*="Ellipse_373"]': {
      '& [class*="st0"]': {
        fill: `${theme.palette.primary.main} !important`,
      },
    },
    '& [id*="Rectangle_546"]': {
      '& [class*="st0"]': {
        fill: `${theme.palette.primary.main} !important`,
      },
    },
    '& [class*="st1"]': {
      fill: `${theme.palette.secondary.light} !important`,
    },
  },
}));

const BoolReadOnly = ({ label, value }) => {
  const classes = useStyles();
  return (
    <div className={classes.labelBox}>
      <InputLabel shrink className={classes.label} htmlFor="component-error">
        {label}
      </InputLabel>
      {value === '-' ? (
        <div>-</div>
      ) : (
        <InputLabel shrink className={classes.label} htmlFor="component-error">
          {/* <Image className={classes.img} src={value ? iconYes : iconNo} /> */}
          <SvgIcon className={classes.mySvgStyle}>
            {value ? (
              <IconYes className={classes.img} alt={'yesicon'} />
            ) : (
              <IconNo className={classes.img} alt={'noicon'} />
            )}
          </SvgIcon>
        </InputLabel>
      )}
    </div>
  );
};

BoolReadOnly.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default BoolReadOnly;
